import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Separator } from './layout/Separator'
import { handleSubmitResult } from '../v2_actions/form'
import { countryList } from '../v2_actions/country'
import { photographList } from '../v2_actions/photograph'
import { CurrencyValue } from './CurrencyValue'
import { Modal } from './layout/Modal'
import { showSuccess } from '../v2_actions/error'
import { useForm, Controller } from 'react-hook-form'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { TextField } from './form/TextField'
import {makeStyles} from "@material-ui/core"
import { Button } from "@material-ui/core"
import { galleryList } from '../v2_actions/gallery'

import Timestamp from './Timestamp'

const formSchema = Yup.object().shape({
    price: Yup.number().required(),
})

const useStyles = makeStyles({
    textField: {
        width: "90%",
    },
    textFieldWithCurrencyWrapper: {
        display: "flex",
        alignItems: "baseline"
    },
    submitButton: {
        width: "95%",
        backgroundColor: "#0c59cf !important",
        boxShadow: "0px 5px 10px rgba(248, 95, 106, 0.23)",
        color: "white",
        textTransform: "inherit",
        fontSize: "16px !important",
        fontWeight: "500",
        margin: 6,
        padding: 12,
        marginTop: 25,
    },
    photograph_info: {
        borderBottom: "1px solid #aaaaaa",
        paddingBottom: "10px",
        marginBottom: "10px"
    }
})

export const PhotographEditor = ({photograph_id, country_id, onClose}) => {

    const classes = useStyles()
    const dispatch = useDispatch()
    const defaultValues = {price: 0}
    const photograph = useSelector(() => photographList.getObject(photograph_id))
    const country = countryList.getCountryForId(country_id)
    
    const formProps = useForm({resolver: yupResolver(formSchema), defaultValues: defaultValues})
    const { handleSubmit, control, clearErrors, reset, getValues, setValue, formState: { errors } } = formProps

    useEffect(() => {
        dispatch(photographList.ensureObjectLoaded(photograph_id))
    }, [photograph_id])

    useEffect(() => {
        if ( photograph && photograph.id ) {
            const values = Object.assign({}, defaultValues, photograph)
            reset(values)
        }
    }, [photograph])

    const onSave = (values) => {
        clearErrors()
        const on_ok = function(json) {
            showSuccess("Saved", "Photograph saved")
            onClose()
            dispatch(galleryList.invalidateGalleryAndPhotographs(photograph.gallery))
        }

        values.id = photograph_id
        return dispatch(photographList.saveObject(values)).then((res) => handleSubmitResult({res, formProps, on_ok: on_ok}))
    }
    
    return (
        <Modal onClose={onClose} title={`Edit photograph`}>

          <div className={classes.photograph_info}>
            <div>
              Name: {photograph.photo_name}
            </div>
            <div>
              Taken at: <Timestamp value={photograph.photograph_taken_at} />
            </div>
          </div>
          
          <form onSubmit={handleSubmit(onSave)}>
            <Controller name="price"
                        control={control}
                        render={(fieldProps) => (
                            <>
                              Price:
                              <div className={classes.textFieldWithCurrencyWrapper}>
                                <CurrencyValue value={null} country={country} />
                                <TextField fieldProps={fieldProps}
                                           type="text"
                                           variant="standard"
                                           placeholder="Photograph price"
                                           className={classes.textField}
                                />
                              </div>
                            </>
                        )}/>

            <Separator height={20} />

            <Button className={classes.submitButton} type="submit">
              Save
            </Button>
            
          </form>
        </Modal>
    )
    
}
